import BoltIcon from '@mui/icons-material/Bolt';
import { Tooltip } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import {
  selectHasExpressModeMealPeriods,
  selectIsExpressUpsellMode,
} from '../../selectors/menu';
import { VisualIndicator } from '../VisualIndicator';

const TOOLTIP_ON =
  'Express upsell mode is ON — upsells are suppressed during the active express-mode meal period.';
const TOOLTIP_OFF =
  'Express upsell mode is OFF — upsells follow normal behavior.';

export const ExpressUpsellIndicator: FC = () => {
  const hasExpressModeMealPeriods = useAppSelector(
    selectHasExpressModeMealPeriods
  );
  // Force a re-evaluation every 60s so the indicator flips when the wall
  // clock crosses an express-mode meal-period boundary even if no other
  // state changes.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!hasExpressModeMealPeriods) return;
    const id = setInterval(() => setTick((n) => n + 1), 60_000);
    return () => clearInterval(id);
  }, [hasExpressModeMealPeriods]);

  const isExpressUpsellMode = useAppSelector(selectIsExpressUpsellMode);

  if (!hasExpressModeMealPeriods) return null;

  return (
    <Tooltip title={isExpressUpsellMode ? TOOLTIP_ON : TOOLTIP_OFF} arrow>
      {/* span wrapper so MUI Tooltip works even when the child is disabled */}
      <span>
        <VisualIndicator
          IconComponent={BoltIcon}
          isActive={isExpressUpsellMode}
          data-testid="express-upsell-mode-indicator"
        />
      </span>
    </Tooltip>
  );
};
